import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 5, // 5s stale time for crisp real-time responsiveness
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: true, // Auto-refetch when returning to window/tab
      refetchInterval: 10000, // Background poll every 10s so multi-user updates appear automatically
    },
  },
});
